import type { CollectionContentsPaginatedData, PaginationRequest } from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

export enum FETCH_RECENTLY_VIEWED {
	START = 'FETCH_RECENTLY_VIEWED_START',
	SUCCESS = 'FETCH_RECENTLY_VIEWED_SUCCESS',
	ERROR = 'FETCH_RECENTLY_VIEWED_ERROR',
}

export type FetchRecentlyViewedAction = AsyncAction<
	typeof FETCH_RECENTLY_VIEWED.START,
	typeof FETCH_RECENTLY_VIEWED.SUCCESS,
	typeof FETCH_RECENTLY_VIEWED.ERROR,
	CollectionContentsPaginatedData,
	{ pagination: PaginationRequest }
>;
